import React from "react";
import { Link } from "react-router-dom";

const MissionVisionHistory = () => {
  return (
    <div className="py-10">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Mission Section */}
          <div className="flex flex-col items-center text-center bg-white shadow-lg p-6 rounded-lg">
            <h2 className="text-2xl font-semibold text-[#07294D] mb-4">
              Mission
            </h2>
            <p className="text-sm md:text-base text-[#07294D] mb-4">
              Our mission is to provide a holistic education that empowers
              students to excel academically, socially, and personally. We focus
              on fostering creativity, critical thinking, and leadership skills.
            </p>
            <Link
              to="/about/history"
              className="mt-4 px-6 py-2 text-white bg-[#07294D] rounded-lg text-sm hover:bg-blue-700"
            >
              Read More
            </Link>
          </div>

          {/* Vision Section */}
          <div className="flex flex-col items-center text-center bg-white shadow-lg p-6 rounded-lg">
            <h2 className="text-2xl font-semibold text-[#07294D] mb-4">
              Vision
            </h2>
            <p className="text-sm md:text-base text-[#07294D] mb-4">
              Our vision is to be a leading institution that nurtures
              innovation, encourages a love for learning, and develops
              responsible global citizens. We aim to create an environment that
              inspires excellence in every student.
            </p>
            <Link
              to="/about/history"
              className="mt-4 px-6 py-2 text-white bg-[#07294D] rounded-lg text-sm hover:bg-blue-700"
            >
              Read More
            </Link>
          </div>

          {/* History Section */}
          <div className="flex flex-col items-center text-center bg-white shadow-lg p-6 rounded-lg">
            <h2 className="text-2xl font-semibold text-[#07294D] mb-4">
              History
            </h2>
            <p className="text-sm md:text-base text-[#07294D] mb-4">
              Established in 2017, Shree Krishna Academy has a long-standing
              tradition of excellence in education. Over the years, we have
              evolved into a beacon of academic success and innovation in our
              community.
            </p>
            <Link
              to="/about/history"
              className="mt-4 px-6 py-2 text-white bg-[#07294D] rounded-lg text-sm hover:bg-blue-700"
            >
              Read More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionVisionHistory;
